import { memo, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import LOCAL_STORAGE from "@utils/localStorage";

import SvgArrow from "@assets/images/live/SvgArrow";

export default memo(function InfoLiveControl({
  currentChannel,
  active,
  playerType,
}) {
  const { t } = useTranslation();
  const defaultLogo = LOCAL_STORAGE.LOGO.GET();
  const [logoSrc, setLogoSrc] = useState(defaultLogo);
  const prevChannelIdRef = useRef(null);

  useEffect(() => {
    // When channel changes, reset to default logo until new image loads
    if (currentChannel?.id !== prevChannelIdRef.current) {
      prevChannelIdRef.current = currentChannel?.id;
      setLogoSrc(defaultLogo);
      
      // Preload the new channel's image
      if (currentChannel?.image) {
        const img = new Image();
        img.onload = () => {
          // Only update if this is still the current channel
          if (currentChannel?.id === prevChannelIdRef.current) {
            setLogoSrc(currentChannel.image);
          }
        };
        img.onerror = () => {
          // Keep default logo on error
          setLogoSrc(defaultLogo);
        };
        img.src = currentChannel.image;
      }
    }
  }, [currentChannel, defaultLogo]);

  return (
    <>
      <div className="info-live-control_wrapper">
        <div
          className={`parent-number-channel${active === 0 ? " active" : ""}`}
        >
          <span className="arrow arrow-up">
            <SvgArrow />
          </span>
          <p className="number-channel">{currentChannel?.position}</p>
          <span className="arrow arrow-down">
            <SvgArrow />
          </span>
        </div>
        <div className="logo">
          <img
            src={logoSrc}
            onError={(e) => (e.target.src = defaultLogo)}
            alt=""
          />
        </div>
        <div className="name-channel">
          <p>{currentChannel?.name}</p>
        </div>
      </div>
    </>
  );
});
